import React from 'react';
import Modal from './Modal';

class People extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() { }

    handleClick(e){
        let currentElem = e.currentTarget;
        //console.log(currentElem)

        let modal = currentElem.childNodes[2];
        modal.classList.toggle(['is-showing']);
        document.querySelector('header').classList.toggle('d-none');
    }

    render() {
        let _this = this;
        let page_id = this.props.page_id;
        let people_data = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.people : [];
        if (!Object.keys(people_data).length) return [];

        let people_html = people_data.member.map((member, key) => {
            return(
                <figure className="people-item" key={key} onClick={_this.handleClick}>
                    <img src={member.image.url} alt={member.name} title={member.name} />
                    <figcaption>
                        <h6>{member.name} <span className="d-block">{member.designation}</span></h6>
                    </figcaption>
                    <Modal {..._this.props} member={member} />
                </figure>
            )

        })
        return (
            <section className="section" style={{ backgroundColor: 'rgb(033, 071, 052)', color: '#ffffff' }}  data-hammenu="white" >
                <div className="main-container">
                    <div className="layout layout-people fullH">
                        <h2 className="title-lg mb-0">People</h2>
                        <div className="grid w-100">
                            {people_html}
                        </div>
                        <div />
                    </div>
                </div>
            </section>

        );
    }
}

export default People;


// WEBPACK FOOTER //
// ./src/components/Practice/People.js